import axios from "../plugins/parseAxios";
export class ContractAssetAPI {
  static getContractAsset(payload) {
    return axios.post("functions/getContractAsset", payload);
  }
  static getContractAssetsByContract(payload) {
    return axios.post("functions/getContractAssetsByContract", payload);
  }
  static updateContractAsset(payload) {
    return axios.post("functions/updateContractAsset", payload);
  }
  static removeContractAsset(payload) {
    return axios.post("functions/removeContractAsset", payload);
  }
  static createContractAsset(payload) {
    return axios.post("functions/createContractAsset", payload);
  }
}
